import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            60 * 1000, // 1 min — évite les refetch immédiats sur remontage (StrictMode, navigation)
      refetchOnWindowFocus: true,     // rafraîchit les données stales quand l'utilisateur revient sur l'onglet
      retry:                false,    // une seule tentative (cohérent avec les hooks existants)
    },
  },
});